import styled from "styled-components";


export interface IStatusBadge {
  statusColor: string
  children: React.ReactNode
  color?: string
}

const StatusBadge = (props: IStatusBadge) => {
  const { statusColor, children, color } = props
  return (
    <Wrapper $statusColor={statusColor} $color={color}>
      {children}
    </Wrapper>
  )
}




const Wrapper = styled.div<{ $statusColor: string, $color?: string }>`
  background: ${props => props.$statusColor};
  color: ${props => props.$color ? props.$color : 'white'};
  padding: 0.3em 0.6em;
  border-radius: 15px;
  font-size: 0.8rem;
  font-weight: 600;
`

export default StatusBadge